// removed by extract-text-webpack-plugin
module.exports = {"input":"_3qYV8pIPTLhYsfylXfc0M3","select":"XJtQSjgQtCLK1SfPY9kHE","formFieldDateOfBirth":"_1XNw_F8tEADNU4pfGu-Uyb","formFieldLocality":"_2rVf6D5dAkaPKTs-qeba6j"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/client-profile/client-profile-form/ClientProfileDataForm.scss
// module id = 1161
// module chunks = 0